export default {
  setSelectedRegion(state, region) {
    state.selected = region;
  },

  setActiveFeature(state, feature) {
    state.active = feature;
  },

  setHover(state, hover) {
    state.hover = hover;
  },

  isClicked(state, click) {
    state.clicked = click;
  },

  setFeature(state, feature) {
    state.feature = feature;
  },

  setEvent(state, event) {
    state.event = event;
  },

  deselect(state) {
    state.selected = null;
  },

  setDownload(state, json) {
    state.download = json;
  },
};
